import { InjectionToken } from '@angular/core'

export const BOOKING_DETAILS_DATA = new InjectionToken<{}>('BOOKING_DETAILS_DATA')
